import React, { createContext, useContext } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useUserToken } from "./UserTokenContext";

// SweetAlert Context oluşturuluyor
const SweetAlertContext = createContext();

const SweetAlertProvider = ({ children }) => {
  const { userLang, languageData } = useUserToken();
  const AICLanguage = languageData[userLang];

  const swalWithBootstrapButtons = withReactContent(
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-lg",
        cancelButton: "btn btn-danger btn-lg",
        actions: "gap-3",
      },
      buttonsStyling: false,
    }),
  );

  const toggleSweetAlert = (callback, text = "") => {
    swalWithBootstrapButtons
      .fire({
        title: AICLanguage.are_you_sure,
        text: text !== "" ? text : AICLanguage.this_action_is_irreversible,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: AICLanguage.yes,
        cancelButtonText: AICLanguage.no,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed && typeof callback === "function") {
          callback();
        }
      });
  };

  // SweetAlertContext'i sağlayan bir provider bileşeni
  return (
    <SweetAlertContext.Provider
      value={{
        toggleSweetAlert,
      }}
    >
      {children}
    </SweetAlertContext.Provider>
  );
};

// Custom hook ile SweetAlertContext'e erişim
const useSweetAlert = () => {
  const context = useContext(SweetAlertContext);
  if (!context) {
    throw new Error("useSweetAlert must be used within a SweetAlertProvider");
  }
  return context;
};

export { SweetAlertProvider, useSweetAlert };
